import axios from 'axios';
import { errorHelper, messageHelper } from '../helper.js';
import {
  GET_LIST_PASSES_URL,
  PASS_ACTION_URL,
  PASS_AVAILABLE_ACTIONS_URL,
} from '../../../vars';

/**
 * @namespace Pass
 * @description  -
 */
export default {
  state: {
    currentPass: null

  },

  mutations: {
    UPDATE_PASS_ALL(state, data) {
      state.currentPass = data;
    },
  },

  actions: {
      /**
       * Получает список данных по ролям(moderator)
       * @param {Object} ctx
       * @param {Object} data Данные для получания списка по ролям
       * @returns {Object} Данные резьтатат запроса
       * @throws {Object} Ошибка запроса данных
       *
       * @memberof RoleList
       */
    async GET_LIST_PASSES(ctx, data) {
      // let allUrl = `${GET_LIST_COUNCILS_URL}?status_id=${data.status_id}`;

      try {
        // console.log('GET_LIST_COUNCILS', data)
          const res = await axios.post(`${GET_LIST_PASSES_URL}`, data,{ headers: {
                Authorization: `Token ${localStorage.token}`
          }});
          return res
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },


    async UPDATE_PASS(ctx, data) {
      // let allUrl = `${GET_LIST_COUNCILS_URL}?status_id=${data.status_id}`;

      try {
        // console.log('GET_LIST_COUNCILS', data)
          const res = await axios.post(`${PASS_ACTION_URL}`, data,{ headers: {
                Authorization: `Token ${localStorage.token}`
          }});
          return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },



    /**
     * NEW COUNCIL
     * @param {Object} ctx
     * @param {Object} data Данные для NEW COUNCIL
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof User
     */
    async NEW_PASS(ctx, data) {
      try {
        const res = await axios.patch(`${GET_LIST_PASSES_URL}`, data, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          console.log('NEW_PASS', e)
          throw e
      }
    },


    /**
     * Получает детальную информацию и записывает
     * @param {Object} ctx
     * @param {String|Number} id Идентификатор
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_PASS_ALL(ctx, id) {
      try {
        const res = await axios.get(`${GET_LIST_PASSES_URL}?id=${id}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_PASS_ALL', res.data);

        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' GET_PASS_ALL');
        throw e;
      }
    },


    /**
     * export to file
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async EXPORT_PASS_DOC(ctx, data) {
      try {
        const res = await axios.post(`${PASS_ACTION_URL}`, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
          return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    async NEXT_PASS_STATUS(ctx, data) {
      try {
        const res = await axios.post(PASS_ACTION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'NEXT_PASS_STATUS');
        throw e;
      }
    },


        /**
     * Получает список доступных действий в Pass
     * @param {Object} ctx
     * @param {String} data pass_id
     * @returns {object} Список доступных действий
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
        async GET_PASS_AVAILABLE_ACTIONS(ctx, data) {
          try {
            const res = await axios.get(`${PASS_AVAILABLE_ACTIONS_URL}?id=${data}`, {
              headers: {
                Authorization: `Token ${localStorage.token}`,
              },
            });
            return res.data
          } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            throw e;
          }
        },

},

  getters: {
    GETTERS_PASS_ALL(state) {
      return state.currentPass;
    },

  },
};
